import { useCallback, useEffect, useState } from 'react';
import { Button, Callout, Typography } from 'seagull';
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import { useOpenMapContactsModal } from "../../../integrations/Accounting/MapContactsModal/useOpenMapContactsModal";
import { useOpenMapServicesModal } from "../../../integrations/Accounting/MapServicesModal/useOpenMapServicesModal";
import { useStoreActions } from "../../../store/store-context";
import styles from "./GBHMapEntitiesCallout.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GBHMapEntitiesCallout = _ref => {
  let {
    services,
    clientID,
    refreshAgreement,
    accounting
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [contactUnintegrated, setContactUnintegrated] = useState(false);
  const policy = getAccountingDetails(accounting).policy;
  const unintegratedServices = policy.getUnintegratedServices(services, accounting);
  const hasUnintegratedServices = !!unintegratedServices.length;
  const openMapContactsModal = useOpenMapContactsModal(clientID, async () => {
    refreshClient(clientID);
  });
  const serviceTemplateIds = policy.getServiceTemplateIdsFromServices(unintegratedServices);
  const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, async () => {
    refreshAgreement();
  });
  const refreshClient = useCallback(async id => {
    if (!id) {
      setContactUnintegrated(false);
      return;
    }
    api.contact.getById(id).then(contact => {
      setContactUnintegrated(!(contact !== null && contact !== void 0 && contact.isIntegrated({
        accounting
      })));
    });
  }, [api.contact, accounting]);
  useEffect(() => {
    refreshClient(clientID);
  }, [clientID, refreshClient]);
  const getCalloutText = (hasUnintegratedServices, contactUnintegrated) => {
    if (hasUnintegratedServices && contactUnintegrated) return 'Contact and services in this agreement are not mapped to';
    if (hasUnintegratedServices && !contactUnintegrated) return 'Some services are not mapped to';
    if (!hasUnintegratedServices && contactUnintegrated) return 'The contact of this agreement is not mapped to';
  };
  return contactUnintegrated || hasUnintegratedServices ? /*#__PURE__*/_jsx(Callout, {
    testId: "map-callout-".concat(accounting),
    withAction: /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [contactUnintegrated && /*#__PURE__*/_jsx(Button, {
        testId: "map-contact-callout-button",
        onClick: () => openMapContactsModal(accounting),
        children: "Map Contact"
      }), hasUnintegratedServices && /*#__PURE__*/_jsx(Button, {
        testId: "map-services-callout-button",
        onClick: () => openMapServicesModal(accounting),
        children: "Map Services"
      })]
    }),
    children: /*#__PURE__*/_jsx(Typography, {
      testId: "map-callout-text-".concat(accounting),
      children: "".concat(getCalloutText(hasUnintegratedServices, contactUnintegrated), " ").concat(getAccountingDetails(accounting).fullName, ".")
    })
  }) : null;
};